
export default async function retrieveOwner(assetContract, tokenId) {
  const url = `https://api.opensea.io/api/v1/asset/${assetContract}/${tokenId}`;

  const response = await fetch(url);
  return response.json()
}
